import { Box, Button, Typography } from '@mui/material';
import React from 'react';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';

import { colors } from 'styles/theme/colors';
import { useServerTranslation } from 'hooks/useServerTranslation';

type Props = {
    productAmount: number;
    showing: boolean;
    toggle: () => void;
};

export default function ProductFilterHeader({ productAmount, toggle, showing }: Props) {
    const { t } = useServerTranslation();

    return (
        <>
            <Box sx={{ marginBottom: 1 }}>
                <Button
                    variant="black"
                    sx={{ display: ['inherit', 'inherit', 'none'], paddingX: 0 }}
                    onClick={toggle}
                    fullWidth
                >
                    <Box display="flex" justifyContent="space-between">
                        <Typography fontSize="16px">
                            {t('filter.filter')}
                            {' '}
                        </Typography>
                        {showing ? <FilterAltOffIcon /> : <FilterAltIcon />}
                    </Box>
                </Button>
            </Box>
            <Typography
                variant="body1"
                sx={{
                    borderBottom: `1px solid ${colors.gray1}`,
                    marginBottom: 2,
                    fontSize: '14px',
                    paddingBottom: 2,
                }}
            >
                {t('product-filter.showing')}
                {' '}
                {productAmount}
                {' '}
                {t('shopping-cart.totals.product-items')}
            </Typography>
        </>
    );
}
